import { useGetFlowsByProcessId } from "@/queries/flows/flows.api";
import type { FlowsType } from "@/types/entities/flows";
import {
  Badge,
  // Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  RowCard,
} from "@elaniintc/goes-design-system";
import { useMemo } from "react";
import { NavLink } from "react-router";
import { ConnectorComponent, DotComponent, ParentLineComponent } from "./ui";
import { getFlowBadgeLabel, getFlowBadgeColor } from "./utils";

interface Props {
  data: FlowsType;
  isFirst?: boolean;
  isLast?: boolean;
  onEdit?: (id: string) => void;
  handleDuplicateFlow: (id: string) => void;
  onViewExecutions?: (id: string) => void;
  onDeleteFlow?: (id: string) => void;
  onStatusChange?: (
    id: string,
    status: "DRAFT" | "PUBLISHED" | "DEPRECATED",
  ) => void;
  parentVersion?: number;
  isVersionLocked?: boolean;
}

const SubFlowCard = ({
  data,
  isFirst,
  isLast,
  onViewExecutions,
  handleDuplicateFlow,
  onEdit,
  onDeleteFlow,
  parentVersion,
  // onStatusChange,
  isVersionLocked = false,
}: Props) => {
  const { data: flows, isPending: isLoading } = useGetFlowsByProcessId(
    data.process_id,
    {
      page: 1,
      perPage: 20,
      order_by: "created_at",
      parent: data.id,
    },
    5000,
  );

  const isParent = useMemo(() => {
    return (flows?.data.length ?? 0) > 0;
  }, [flows]);

  // let statusColor = "";
  // if (data.status === "DRAFT" || data.status === "IN_PROCESS")
  //   statusColor = "action";
  // else if (data.status === "PUBLISHED") statusColor = "success";
  // else if (data.status === "DEPRECATED") statusColor = "danger";
  // const getLabel = () => {
  //   if (data.status === "DRAFT" || data.status === "IN_PROCESS")
  //     return "Borrador";
  //   else if (data.status === "PUBLISHED") return "Publicado";
  //   else if (data.status === "DEPRECATED") return "Deprecado";
  //   return "Desconocido";
  // };
  return (
    <div className="pl-4 flex flex-col gap-2 relative">
      {isParent && (flows?.data.length ?? 0) > 1 && (
        <ParentLineComponent leftPx={25} />
      )}
      <div className="flex">
        <ConnectorComponent isFirst={isFirst} isLast={isLast} />
        <div className="flex flex-auto">
          <DotComponent shouldShow={true} />
          <NavLink
            to={`/procesos/${data.process_id}/flujo/${data.id}`}
            className="flex-auto"
          >
            <RowCard
              title={data.name || "Sin nombre"}
              key={data.id}
              subtitle={`v${parentVersion || data.version || 1}`}
              //subtitle={"v.1.0.0"}
              color="info"
              icon={{
                name: "users-rectangle",
                type: "fas",
                size: "lg",
              }}
            >
              <RowCard.Right>
                <div className="flex gap-2 items-center">
                  <Badge
                    variant={
                      getFlowBadgeColor(data) as
                        | "neutral"
                        | "success"
                        | "action"
                        | "warning"
                        | "danger"
                    }
                    size="xs"
                    shape="square"
                  >
                    {getFlowBadgeLabel(data)}
                  </Badge>
                  {/* <Badge
                    variant={
                      statusColor as
                        | "neutral"
                        | "success"
                        | "action"
                        | "warning"
                    }
                    size="xs"
                    shape="square"
                  >
                    {getLabel()}
                  </Badge> */}
                  {/* {data.review_status === "DENIED" && (
                    <Badge variant="danger" size="xs" shape="square">
                      Rechazado
                    </Badge>
                  )}
                  {data.review_status === "APPROVED" &&
                    statusColor !== "success" && (
                      <Badge variant="success" size="xs" shape="square">
                        Aprobado
                      </Badge>
                    )} */}
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        variant="ghost"
                        size="xs"
                        className="size-8 cursor-pointer"
                      >
                        <Icon type="far" name="ellipsis-vertical" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className="w-[222px] min-w-56 rounded-lg border-neutral text-body font-normal p-2 font-geist"
                      side="bottom"
                      align="end"
                      sideOffset={4}
                    >
                      {!isVersionLocked && (
                        <>
                          <DropdownMenuGroup>
                            <DropdownMenuItem
                              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (onEdit) onEdit(data.id!);
                              }}
                            >
                              Editar flujo
                            </DropdownMenuItem>
                            <DropdownMenuItem
                              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                              onClick={() => {
                                handleDuplicateFlow(data.id!);
                              }}
                            >
                              Duplicar flujo
                            </DropdownMenuItem>
                            {data.status !== "PUBLISHED" && (
                              <DropdownMenuItem
                                className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (onDeleteFlow) onDeleteFlow(data.id!);
                                }}
                              >
                                Eliminar flujo
                              </DropdownMenuItem>
                            )}
                          </DropdownMenuGroup>
                          <DropdownMenuSeparator className="bg-(--border-neutral-quiet) my-2.5" />
                        </>
                      )}
                      <DropdownMenuGroup>
                        {/* {data?.review_status === "APPROVED" && (
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (onStatusChange)
                                onStatusChange(data.id!, "PUBLISHED");
                            }}
                          >
                            Aprobar flujo
                          </DropdownMenuItem>
                        )}
                        {data?.status !== "PUBLISHED" && (
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (onStatusChange)
                                onStatusChange(data.id!, "DEPRECATED");
                            }}
                          >
                            Deprecar flujo
                          </DropdownMenuItem>
                        )} */}
                        <DropdownMenuItem
                          className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (onViewExecutions) onViewExecutions(data.id!);
                          }}
                        >
                          Ejecuciones
                        </DropdownMenuItem>
                      </DropdownMenuGroup>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </RowCard.Right>
            </RowCard>
          </NavLink>
        </div>
      </div>

      {(flows?.data?.length || 0) > 0 && (
        <div className=" flex flex-col gap-2">
          {flows?.data.map((flow) => (
            <SubFlowCard
              data={flow}
              handleDuplicateFlow={handleDuplicateFlow}
              onEdit={onEdit}
              key={flow.id || ""}
              isFirst={flows.data.length > 0 && flow.id === flows.data[0].id}
              isLast={
                flows.data.length > 0 &&
                flow.id === flows.data[flows.data.length - 1].id
              }
              onDeleteFlow={onDeleteFlow}
              onViewExecutions={onViewExecutions}
              parentVersion={parentVersion}
              isVersionLocked={isVersionLocked}
            />
          ))}
        </div>
      )}
      {isLoading && (
        <div className="pl-4 w-full flex justify-center">
          <Icon
            type="far"
            name="spinner-third"
            className="text-body-quiet text-sm animate-spin"
          />
        </div>
      )}
    </div>
  );
};

export default SubFlowCard;
